import React, { useState } from "react";
import IconPlateInfo from "../../../Icons/Command/PlateInfo";
import IconPlateSchedule from "../../../Icons/Command/PlateSchedule";
import { PlateAddress } from "../../../Model/PlateAddress";
import CommandPanel from "../../CommandPanel/CommandPanel";
import CommandPanelHeaderButton from "../../CommandPanel/CommandPanelHeaderButton";
import PlateInformationData from "./PlateInformationData";
import PlateInformationSchedule from "./PlateInformationSchedule";

enum View {
  SCHEDULE = "SCHEDULE",
  DATA = "DATA",
}

type Props = {
  style?: React.CSSProperties;
  backBtn: () => void;
  plateAddress: PlateAddress;
};

function PlateInformation({ plateAddress, backBtn, style = {} }: Props) {
  const [plateInformationView, setPlateInformationView] = useState(
    View.SCHEDULE
  );

  return (
    <CommandPanel
      style={{
        ...style,
        height: "100%",
      }}
    >
      <CommandPanel.PlateInfoHeader plateAddresses={[plateAddress]}>
        <CommandPanelHeaderButton
          id={View.SCHEDULE}
          icon={<IconPlateSchedule />}
          isSelected={plateInformationView === View.SCHEDULE}
          onClick={() => setPlateInformationView(View.SCHEDULE)}
        />
        <CommandPanelHeaderButton
          id={View.DATA}
          icon={<IconPlateInfo />}
          isSelected={plateInformationView === View.DATA}
          onClick={() => setPlateInformationView(View.DATA)}
        />
      </CommandPanel.PlateInfoHeader>
      <CommandPanel.BackArrowHeader
        title={
          plateInformationView === View.DATA
            ? "Plate Information"
            : "Plate Schedule"
        }
        onBackArrowClick={backBtn}
      />
      <CommandPanel.VerticalContent>
        {plateInformationView === View.DATA && (
          <PlateInformationData
            plateAddress={plateAddress}
            style={{
              paddingLeft: "20px",
              paddingRight: "20px",
            }}
          />
        )}
        {plateInformationView === View.SCHEDULE && (
          <PlateInformationSchedule
            plateAddress={plateAddress}
            style={{
              paddingLeft: "20px",
              paddingRight: "20px",
            }}
          />
        )}
      </CommandPanel.VerticalContent>
    </CommandPanel>
  );
}

function arePropsEqual(prevProps: Props, nextProps: Props) {
  return (
    prevProps.plateAddress.id === nextProps.plateAddress.id &&
    prevProps.plateAddress.usedByPlate?.id ===
      nextProps.plateAddress.usedByPlate?.id &&
    prevProps.plateAddress.usedByPlate?.plateId ===
      nextProps.plateAddress.usedByPlate?.plateId &&
    prevProps.plateAddress.reservedByPlate?.id ===
      nextProps.plateAddress.reservedByPlate?.id &&
    prevProps.plateAddress.reservedByPlate?.plateId ===
      nextProps.plateAddress.reservedByPlate?.plateId
  );
}

export default React.memo(PlateInformation, arePropsEqual);
